export default "__VITE_ASSET__DKmzXQqZ__"